import { Controller } from "@hotwired/stimulus"

// Filters translation language rows by completion status (all / missing / complete).
// Updates the visible count in the summary header after filtering.
export default class extends Controller {
  static targets = ["row", "filterButton", "visibleCount"]

  filter(event) {
    const mode = event.currentTarget.dataset.filter

    // Update active button state. The buttons are Ui::ButtonComponent toggles
    // styled via `data-active`, so we flip that (drives the styling) plus
    // aria-pressed (a11y) — no DS class names live here.
    this.filterButtonTargets.forEach((btn) => {
      const isActive = btn.dataset.filter === mode
      btn.dataset.active = String(isActive)
      btn.setAttribute("aria-pressed", String(isActive))
    })

    let visibleCount = 0

    this.rowTargets.forEach((row) => {
      const filled = parseInt(row.dataset.filledCount, 10)
      const total = parseInt(row.dataset.totalFields, 10)
      let visible = true

      if (mode === "missing" && filled >= total) {
        visible = false
      } else if (mode === "complete" && filled < total) {
        visible = false
      }

      row.style.display = visible ? "" : "none"
      if (visible) visibleCount++
    })

    // Update the visible count in the header
    if (this.hasVisibleCountTarget) {
      this.visibleCountTarget.textContent = visibleCount
    }
  }
}
